
export default {
    name: "popup_jukebox",
    props: {
        isUserMuted: { type: Boolean, default: false },
    },
    data() {
        return {
            currentView: "intro",
            currentWeek: 1,
            totalCoins: 0,
            isLoading: true,
            _preloadQueue: null,
            _spinSfx: null,
            _prizeSfx: null,

            userCollections: [],

            bonusRewards: ["festival_points_5", "festival_points_10", "extra_festival_coin"],

            selectedLang: "en",
            langText: {
                en: {
                    title: "The Fiesta Jukebox",
                    fiestaLabel: "MyWellness Fiesta 2026",
                    introDesc: "Play and reveal your reward. Discover weekly limited-edition collectibles, win bonus points and complete your collection to unlock even bigger rewards.",
                    weekLabelEn: "Week {{0}} of 6",
                    weekStatusFormat: "Week {0} - {1}",
                    weekAvailable: "Available Now",
                    weekComingSoon: "Coming Soon",
                    weekDropEnded: "Drop Ended",
                    collectionDesc: "Collect a complete set of {{0}} to earn <span class='font-bold'>+200</span> MyWellness Points!",
                    tabVinyls: "Vinyl",
                    tabPlushie: "Plushy",
                    tabBackground: "Avatar GIF",
                    shufflingLabel: "SHUFFLING....",
                    pointsLabel: "MyWellness Points",
                    playBtn: "Play",
                    howToPlayBtn: "How to Play",
                    collectionBtn: "My Collection",
                    totalCoinsLabel: "Total Coins",
                    jukeboxCollectionBtn: "Jukebox Collection",
                    tutorialTitle: "How to Play",
                    tutorial_1_title: "1. Use Your Jukebox Coin",
                    tutorial_1_desc: "Earn Jukebox Coins from daily logins!",
                    tutorial_2_title: "2. Press Play & Reveal",
                    tutorial_2_desc: "Use 1 Jukebox Coin to play and reveal your reward — from bonus points to exclusive collectibles.",
                    tutorial_3_title: "3. Discover Weekly Collectibles",
                    tutorial_3_desc: "Look out for new Tunetopian Plushies, Wellness Pillar Vinyl Albums and GIF Profile Backgrounds released each week.",
                    tutorial_4_title: "4. Collect & Earn More",
                    tutorial_4_desc: "Collect all 6 Plushies or 6 Vinyl Albums to earn +200 MyWellness Points per collection.",
                    tutorial_4_bonus: "Plus, look out for +5 and +10 bonus point rewards!",
                    tutorial_5_title: "Got an extra Jukebox Coin?",
                    tutorial_5_desc: "Play again within the same week! Extra coins cannot be accumulated or carried forward.",
                    rewardsTitle: "Jukebox Collection",
                    rewardsDesc: "New collectibles drop every week.<br>Play, collect and complete the full set",
                    bonusRewardsLabel: "Bonus Rewards",
                    bonusNames: {
                        festival_points_5: "Carnival Points 5",
                        festival_points_10: "Carnival Points 10",
                        extra_festival_coin: "Extra Carnival Coin",
                    },
                    weekAvailable: "Available Now",
                    weekComingSoon: "Coming Soon",
                    weekDropEnded: "Drop Ended",
                    plushyLabel: "Plushy",
                    vinylLabel: "Vinyl",
                    avatarGifLabel: "Avatar GIF",
                    collectionTitle: "My Collection",
                    congrats: "Congratulation!",
                    continueBtn: "Continue",
                    shuffleMessages: [
                        "Will this be your lucky track?",
                        "Let the good tunes roll...",
                        "Your next reward is on repeat...",
                        "A reward is about to drop...",
                        "Stay tuned for your reward...",
                        "What's your next hit?",
                        "The beat is building...",
                        "Your next track is coming up...",
                    ],
                    resultPlushieTitle: "Tunetopian Plushie Unlocked!",
                    resultPlushieSubtitle: "Limited-Edition<br>Festival Collectible",
                    resultBackgroundTitle: "Avatar Background Unlocked!",
                    resultBackgroundSubtitle: "Limited-Edition<br>Animated Background",
                    resultMywellnessTitle: "MyWellness: Greatest Hits Unlocked!",
                    resultVinylUnlocked: "Unlocked!",
                    resultVinylSpecialEdition: "Special-Edition Vinyl",
                    resultVinylLimitedEdition: "Limited-Edition Vinyl",
                    resultEncoreTitle: "Encore! One More Play.",
                    resultEncoreSubtitle: "You've won a Bonus Festival Coin.",
                    resultPointsTitle: "Wellness Points!",
                    resultPointsSubtitle: "Keep the beat going.",
                    vinylSubs: {
                        groove_together: "Family Wellness",
                        hardrock_hq: "Workplace Wellness",
                        mywellness: "MyWellness",
                        orchard_pop: "Physical Wellness",
                        peacetopia: "Mental Wellness",
                        wealth_symphony: "Financial Wellness",
                    },
                },
                cn: {
                    title: "健康音乐专区",
                    fiestaLabel: "2026 健康嘉年华",
                    introDesc: "点击播放，解锁专属奖励。每周解锁限量版藏品，赢取积分奖励；集齐全套藏品，即可解锁丰厚大奖。",
                    weekLabelEn: "共 6 期活动｜第 {{0}} 期",
                    weekStatusFormat: "第 {0} 期 - {1}",
                    weekAvailable: "即刻可参与",
                    weekComingSoon: "即将开启",
                    weekDropEnded: "活动已结束",
                    collectionDesc: "集齐全套{{0}}可获得 <span class='font-bold'>+200</span> 健康积分！",
                    tabVinyls: "黑胶唱片",
                    tabPlushie: "毛绒玩偶",
                    tabBackground: "动态背景图",
                    playBtn: "开始抽取",
                    howToPlayBtn: "玩法说明",
                    collectionBtn: "我的藏品",
                    totalCoinsLabel: "金币总数",
                    jukeboxCollectionBtn: "音乐专区藏品库",
                    tutorialTitle: "玩法说明",
                    tutorial_1_title: "1. 使用音乐专区金币",
                    tutorial_1_desc: "每日登录即可领取音乐专区金币！",
                    tutorial_2_title: "2. 点击播放, 揭晓奖励",
                    tutorial_2_desc: "消耗 1 枚音乐专区金币即可参与抽取，解锁积分奖励与专属典藏藏品。",
                    tutorial_3_title: "3. 探索每周限定藏品",
                    tutorial_3_desc: "每周限时上新音律乐园毛绒玩偶、健康维度黑胶唱片及个人主页动态背景图。",
                    tutorial_4_title: "4. 集齐藏品，赢取丰厚奖励",
                    tutorial_4_desc: "集齐全套 6 款毛绒玩偶或 6 款黑胶唱片，每套可额外获得 200 点健康积分。",
                    tutorial_4_bonus: "同时还可随机抽取额外 5 点或 10 点积分奖励！",
                    tutorial_5_title: "拥有多余音乐专区金币？",
                    tutorial_5_desc: "可在本周内再次参与抽取！额外金币不可累计、不可顺延至下周。",
                    rewardsTitle: "音乐专区藏品库",
                    rewardsDesc: "每周限时上新专属藏品。参与游戏、集齐全套典藏好物。",
                    bonusRewardsLabel: "额外奖励",
                    bonusNames: {
                        festival_points_5: "5 点嘉年华积分",
                        festival_points_10: "10 点嘉年华积分",
                        extra_festival_coin: "额外嘉年华金币",
                    },
                    weekAvailable: "即刻可参与",
                    weekComingSoon: "即将开启",
                    weekDropEnded: "活动结束",
                    plushyLabel: "毛绒玩偶",
                    vinylLabel: "黑胶唱片",
                    avatarGifLabel: "头像动态贴图",
                    collectionTitle: "我的藏品",
                    congrats: "恭喜你！",
                    continueBtn: "继续",
                    shufflingLabel: "随机抽取中......",
                    pointsLabel: "健康积分",
                    shuffleMessages: [
                        "这首专属旋律，会是你的幸运之音吗？",
                        "悦动旋律，乐享美好......",
                        "专属好礼，循环来袭......",
                        "惊喜奖励即将揭晓......",
                        "敬请期待专属惊喜奖励......",
                        "下一首热门旋律花落谁家？",
                        "节奏渐起，惊喜将至......",
                        "专属旋律即将奏响......",
                    ],
                    resultPlushieTitle: "成功解锁音律乐园毛绒玩偶！",
                    resultPlushieSubtitle: "嘉年华限量版藏品",
                    resultBackgroundTitle: "成功解锁动态背景贴图！",
                    resultBackgroundSubtitle: "嘉年华限量<br>动态背景",
                    resultMywellnessTitle: "解锁健康精选典藏好物！",
                    resultVinylUnlocked: "已解锁！",
                    resultVinylSpecialEdition: "健康专属 · 特别版黑胶唱片",
                    resultVinylLimitedEdition: "限量版黑胶唱片",
                    resultEncoreTitle: "加场福利！获得一次额外抽取机会",
                    resultEncoreSubtitle: "你已获得 1 枚额外嘉年华金币。",
                    resultPointsTitle: "健康积分！",
                    resultPointsSubtitle: "律动不止，乐趣不停。",
                    vinylSubs: {
                        groove_together: "同心同乐",
                        hardrock_hq: "奋进职场",
                        mywellness: "健康精选",
                        orchard_pop: "果园流行风",
                        peacetopia: "静谧乌托邦",
                        wealth_symphony: "财富交响",
                    },
                }
            },

            weeklyDrops: [
                { plushie: "red_panda", vinyl: "groove_together", bg: "background_1" },
                { plushie: "owl", vinyl: "hardrock_hq", bg: "background_2" },
                { plushie: "capybara", vinyl: "mywellness", bg: "background_3" },
                { plushie: "polar_bear", vinyl: "orchard_pop", bg: "background_4" },
                { plushie: "fox", vinyl: "peacetopia", bg: "background_5" },
                { plushie: "wolf", vinyl: "wealth_symphony", bg: "background_6" },
            ],

            activeTab: "vinyls",
            collectionTabs: ["vinyls", "plushie", "background"],

            collectionsData: {
                vinyls: [
                    "groove_together",
                    "hardrock_hq",
                    "mywellness",
                    "orchard_pop",
                    "peacetopia",
                    "wealth_symphony",
                ],
                plushie: ["red_panda", "owl", "capybara", "polar_bear", "fox", "wolf"],
                background: [
                    "background_1",
                    "background_2",
                    "background_3",
                    "background_4",
                    "background_5",
                    "background_6",
                ],
            },

            shuffleMessages: [
                "Will this be your lucky track?",
                "Let the good tunes roll...",
                "Your next reward is on repeat...",
                "A reward is about to drop...",
                "Stay tuned for your reward...",
                "What's your next hit?",
                "The beat is building...",
                "Your next track is coming up...",
            ],
            shuffleMessage: "Will this be your lucky track?",

            shuffleDiscs: [],
            currentRotation: 0,
            currentTrackOffset: 0,
            winningDisc: null,
            _shuffleRaf: null,

            item: null,
            stamps: []
        }
    },
    computed: {
        processedCollectionTabs() {
            return this.collectionTabs.map((category) => {
                const list = this.collectionsData[category] || [];
                const total = list.length;
                const collected = list.filter((id) => {
                    const key = id.startsWith(`${category}_`) ? id : `${category}_${id}`;
                    return this.userCollections.includes(key);
                }).length;

                return {
                    id: category,
                    name: this.getTabName(category),
                    count: `${collected}/${total}`
                };
            });
        },
        currentCollectionList() {
            const category = this.activeTab;
            const list = this.collectionsData[category] || [];
            return list.map((id) => {
                const key = id.startsWith(`${category}_`) ? id : `${category}_${id}`;
                return {
                    id,
                    name: this.formatName(id),
                    unlocked: this.userCollections.includes(key),
                };
            });
        },
        resultReward() {
            if (!this.winningDisc) {
                return { title: "", subtitle: "", points: "" };
            }

            const parts = this.winningDisc.split("_");
            const category = parts[0];
            const itemId = parts.slice(1).join("_");
            const t = this.langText[this.selectedLang] || this.langText.en;

            if (category === "plushie") {
                return {
                    title: t.resultPlushieTitle,
                    subtitle: t.resultPlushieSubtitle,
                    points: "20"
                };
            }

            if (category === "background") {
                return {
                    title: t.resultBackgroundTitle,
                    subtitle: t.resultBackgroundSubtitle,
                    points: "20"
                };
            }

            if (category === "vinyls") {
                const prefix = t.vinylSubs[itemId] || "";
                const isSpecial = itemId === "mywellness";
                const title = isSpecial
                    ? t.resultMywellnessTitle
                    : `${this.formatName(itemId)} ${t.resultVinylUnlocked}`;
                const editionLabel = isSpecial
                    ? t.resultVinylSpecialEdition
                    : t.resultVinylLimitedEdition;

                return {
                    title,
                    subtitle: `${prefix}<br>${editionLabel}`,
                    points: "20"
                };
            }

            if (category === "bonus") {
                if (itemId === "extra_festival_coin") {
                    return {
                        title: t.resultEncoreTitle,
                        subtitle: t.resultEncoreSubtitle,
                        points: ""
                    };
                }
                const pts = parts[parts.length - 1]
                return {
                    title: `${pts} ${t.resultPointsTitle}`,
                    subtitle: t.resultPointsSubtitle,
                    points: pts
                };
            }

            return { title: "Unlocked!", subtitle: "", points: "" };
        },
        resultImage() {
            if (!this.winningDisc) return "";
            return this.formattedAssetUrl(`/static/images/jukebox/suffle/${this.winningDisc}.png`);
        }
    },
    watch: {
        selectedLang(value) {
            this.$emit("update:selectedLang", value);
        },
        isUserMuted(value) {
            if (!value) return;
            this.stopSfx(this._spinSfx);
            this.stopSfx(this._prizeSfx);
        }
    },
    mounted() {
        this.initSfx();
        this.initJukebox();
    },
    beforeDestroy() {
        this.stopShuffleAnimation();
        this.destroyPreloadQueue();
        this.destroySfx();
    },
    methods: {
        processName(item){
            console.log(item)
            switch(item){
                case "Hardrock Hq":
                    return "Hardrock HQ"
                case "Mywellness":
                    return "MyWellness Fiesta"
                default: 
                    return item
            }
        },
        initSfx() {
            this._spinSfx = new Audio(this.formattedAssetUrl("/static/musics/spin.wav"));
            this._prizeSfx = new Audio(this.formattedAssetUrl("/static/musics/prize.wav"));

            this._spinSfx.loop = true;
            [this._spinSfx, this._prizeSfx].forEach((sfx) => {
                sfx.preload = "auto";
                sfx.volume = 0.6;
                sfx.load();
            });
        },
        playSfx(sfx) {
            if (!sfx || this.isUserMuted) return;

            sfx.currentTime = 0;
            const playPromise = sfx.play();
            if (playPromise?.catch) playPromise.catch((err) => console.error(err));
        },
        stopSfx(sfx) {
            if (!sfx) return;

            sfx.pause();
            sfx.currentTime = 0;
        },
        destroySfx() {
            [this._spinSfx, this._prizeSfx].forEach((sfx) => {
                if (!sfx) return;
                sfx.pause();
                sfx.removeAttribute("src");
            });

            this._spinSfx = null;
            this._prizeSfx = null;
        },
       formatName(str) {
            return str ? _.startCase(str) : "";
        },
        formatBonusName(bonusId) {
            const t = this.langText[this.selectedLang] || this.langText.en;
            const map = t.bonusNames || {};
            return map[bonusId] || this.formatName(bonusId);
        },
        getCollectionImage(category, item) {
            let status = "";
            if (item.unlocked && category === "vinyls") {
                status = "_collected";
            }
            return this.formattedAssetUrl(
                `/static/images/jukebox/${category}/${item.id}${status}.png`
            );
        },
        async initJukebox() {;
            this.isLoading = true
            try {
                await Promise.all([this.preloadAssets(), this.onFetchGameData()]);
            } catch (e) {
                console.error("[Jukebox] init failed:", e);
            } finally {
                this.isLoading = false;
            }
        },
        onFetchGameData() {
            return new Promise((resolve) => {
                this.$axios
                    .$get("/jukebox", this.tokenHeader)
                    .then((res) => {
                        console.log("jukeboxCallback", res);
                        const item = res.item || {};
                        this.currentWeek = res.week || 1;
                        this.item = item;
                        this.totalCoins = Math.max(item.coins || 0, 0);
                        this.userCollections = this.buildUserCollections(item.collections);
                        resolve();
                    })
                    .catch((err) => {
                        console.error("jukeboxError", err);
                        this.onHandleApiError(err);
                        resolve();
                    });
            });
        },
        buildUserCollections(collections = []) {
            if (Array.isArray(collections)) return [...collections];
            return Object.entries(collections)
                .filter(([, count]) => count > 0)
                .map(([key]) => key);
        },
        getAllAssetUrls() {
            const urls = [];

            urls.push("/static/images/jukebox/suffle_circle_box.png");
            urls.push("/static/images/jukebox/suffling_box.png");
            urls.push("/static/images/jukebox/suffling_box_white.png");
            urls.push("/static/images/jukebox/wellnesses.png");

            this.bonusRewards.forEach((id) => {
                urls.push(`/static/images/jukebox/suffle/bonus_${id}.png`);
            });

            this.collectionsData.plushie.forEach((id) => {
                urls.push(`/static/images/jukebox/suffle/plushie_${id}.png`);
            });

            this.collectionsData.vinyls.forEach((id) => {
                urls.push(`/static/images/jukebox/suffle/vinyls_${id}.png`);
            });

            this.collectionsData.background.forEach((id) => {
                urls.push(`/static/images/jukebox/suffle/${id}.png`);
            });

            return [...new Set(urls)].map((u) => this.formattedAssetUrl(u));
        },
        preloadAssets() {
            return new Promise((resolve) => {
                const queue = new createjs.LoadQueue(true);
                this._preloadQueue = queue;

                const finish = () => resolve();

                queue.on("complete", finish);
                queue.on("error", finish);

                const urls = this.getAllAssetUrls();
                const manifest = urls.map((src, id) => ({
                    id: `asset_${id}`,
                    src,
                    type: createjs.Types.IMAGE
                }));

                try {
                    if (manifest.length === 0) {
                        finish();
                    } else {
                        queue.loadManifest(manifest, true);
                    }
                } catch (e) {
                    console.error("[Jukebox Preload] loadManifest error:", e);
                    finish();
                }
            })
        },
        destroyPreloadQueue() {
            if (this._preloadQueue) {
                try {
                    this._preloadQueue.removeAllEventListeners();
                    this._preloadQueue.close();
                } catch (e) {}
                this._preloadQueue = null;
            }
        },
        onChangeCollectionTab(tabId) {
            if (this.activeTab === tabId) {
                if (this.$refs.collectionScroll) {
                    this.$refs.collectionScroll.scrollTop = 0;
                }
                return;
            }

            this.activeTab = tabId;

            this.$nextTick(() => {
                if (this.$refs.collectionScroll) {
                    this.$refs.collectionScroll.scrollTop = 0;
                }
            });
        },
        onClickCloseBtn() {
            this.stopSfx(this._spinSfx);
            this.stopSfx(this._prizeSfx);
            this.$emit("update:currentPopupItem", null);
            this.onHandleTriggerAnalytics(`close@jukebox`);
        },
        changeView(viewName) {
            if (viewName === "collection" && this.item) {
                this.userCollections = this.buildUserCollections(this.item.collections);
            }
            this.currentView = viewName;
        },
        buildShuffleDiscs() {
            let discs = [];

            const drop = this.weeklyDrops[this.currentWeek - 1];
            discs.push(`plushie_${drop.plushie}`);
            discs.push(`vinyls_${drop.vinyl}`);
            discs.push(drop.bg);

            this.bonusRewards.forEach((id) => discs.push(`bonus_${id}`));

            for (let i = discs.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [discs[i], discs[j]] = [discs[j], discs[i]];
            }

            const baseDiscs = [...discs];
            while (discs.length > 0 && discs.length < 15) {
                discs = discs.concat(baseDiscs);
            }

            this.shuffleDiscs = discs;
        },
        getDiscStyle(i) {
            const n = this.shuffleDiscs.length || 1;
            const slotsOnCircle = 7;
            const spacing = 360 / slotsOnCircle;
            const loop = n * spacing;

            let pos = (i * spacing + this.currentRotation) % loop;
            if (pos < 0) pos += loop;

            const arcLen = 180;

            if (pos <= arcLen) {
                const angle = 180 + pos;
                const rad = (angle * Math.PI) / 180;

                const cx = 50;
                const cy = 100;
                const r = 34;

                return {
                    left: `${cx + r * Math.cos(rad)}%`,
                    top: `${cy + r * Math.sin(rad)}%`,
                    transform: "translate(-50%, -50%)",
                    opacity: 1,
                    visibility: "visible",
                    zIndex: 20
                };
            }

            return {
                left: "50%",
                top: "110%",
                transform: "translate(-50%, -50%) scale(0.4)",
                opacity: 0,
                visibility: "hidden",
                zIndex: 0
            };
        },
        stopShuffleAnimation() {
            if (this._shuffleRaf) {
                cancelAnimationFrame(this._shuffleRaf);
                this._shuffleRaf = null;
            }
        },
        startShuffleAnimation() {
            this.stopShuffleAnimation();
            this.currentRotation = 0;
            this.currentTrackOffset = 0;

            const n = this.shuffleDiscs.length || 1;
            const spacing = 360 / 7;
            const loop = n * spacing;

            const winnerIndex = Math.max(0, this.shuffleDiscs.indexOf(this.winningDisc));
            this.winningDisc = this.shuffleDiscs[winnerIndex];

            let targetRot = 90 - winnerIndex * spacing;
            while (targetRot < 0) targetRot += loop;

            const totalRotation = -(2 * loop - targetRot + 1);
            const totalTrackDistance = 5 * 50;

            const duration = 4500;
            const start = performance.now();

            const tick = (now) => {
                const p = Math.min((now - start) / duration, 1);
                const eased = 1 - Math.pow(1 - p, 3);

                this.currentRotation = eased * totalRotation;
                this.currentTrackOffset = (eased * totalTrackDistance) % 50;

                if (p < 1) {
                    this._shuffleRaf = requestAnimationFrame(tick);
                } else {
                    this._shuffleRaf = null;
                    this.stopSfx(this._spinSfx);
                    this.playSfx(this._prizeSfx);
                    this.stamps.forEach((stamp) => {
                        this.$store.commit("stamp/addItem", stamp);
                    })
                    this.currentView = "result";
                }
            }

            this._shuffleRaf = requestAnimationFrame(tick);
        },
        getWeekLabel(week) {
            const t = this.langText[this.selectedLang] || this.langText.en;
            const displayWeek = Math.min(week, 6);
            return (t.weekLabelEn || "").replace("{{0}}", displayWeek);
        },
        getTabName(tabId) {
            const t = this.langText[this.selectedLang] || this.langText.en;
            const map = {
                vinyls: t.tabVinyls,
                plushie: t.tabPlushie,
                background: t.tabBackground,
            };
            return map[tabId] || this.formatName(tabId);
        },
        getCollectionDesc(tabId) {
            const t = this.langText[this.selectedLang] || this.langText.en;
            const name = this.getTabName(tabId);
            return (t.collectionDesc || "").replace("{{0}}", name);
        },
        getWeekStatus(week) {
            const t = this.langText[this.selectedLang] || this.langText.en;
            let status;
            if (week < this.currentWeek) status = t.weekDropEnded;
            else if (week === this.currentWeek) status = t.weekAvailable;
            else status = t.weekComingSoon;
            return (t.weekStatusFormat || "Week {0} - {1}").replace("{0}", week).replace("{1}", status);
        },
        pickRandomShuffleMessage() {
            const t = this.langText[this.selectedLang] || this.langText.en;
            const messages = t.shuffleMessages;
            const idx = Math.floor(Math.random() * messages.length);
            this.shuffleMessage = messages[idx];
        },
        onClickPlay() {
            if (this.totalCoins <= 0 || this.isLoading || this.currentView !== "intro") {
                return;
            }

            this.pickRandomShuffleMessage();
            this.buildShuffleDiscs();
            this.playSfx(this._spinSfx);
            this.currentView = "shuffling";

            const oldCollections = [...(this.item?.collections || [])];

            this.$axios
                .$post("/jukebox/play", {}, this.tokenHeader)
                .then((res) => {
                    console.log("jukeboxPlayCallback", res);
                    this.item = res.item;
                    this.winningDisc = res.winningDisc;
                    this.totalCoins = Math.max(res.item.coins, 0);
                    this.userCollections = this.buildUserCollections(res.item.collections);
                    this.stamps = res.stamps || [];
                    this.onHandleTriggerAnalytics(`play@jukebox`);

                    if (this.winningDisc.startsWith("background_") && !oldCollections.includes(this.winningDisc)) {
                        const bgIndex = parseInt(this.winningDisc.split("_")[1]);
                        this.$emit("onWinBackground", bgIndex);
                    }

                    this.$nextTick(() => {
                        this.startShuffleAnimation();
                    });
                })
                .catch((err) => {
                    console.error("jukeboxPlayError", err);
                    this.stopSfx(this._spinSfx);
                    this.onHandleApiError(err);
                    this.currentView = "intro";
                });
        },
        onClickResultContinue() {
            this.winningDisc = null;
            this.stamps = [];
            this.currentView = "intro";
        }
    }
}
